import { ActionKeys } from '~/actions/constants';
import { ActionTypes } from '~/actions/index';
import Promo from '~/types/Promo';

export type PromosState = {
  readonly data: { [code: string]: Readonly<Promo> };
  readonly errorCode: string;
};

const initialState: PromosState = {
  data: {},
  errorCode: '',
};

export default function promosReducer(state: PromosState = initialState, action: ActionTypes) {
  switch (action.type) {
    case ActionKeys.DID_FETCH_PROMO:
      return action.promo
        ? {
            ...state,
            data: {
              ...state.data,
              [action.promo.code!]: action.promo,
            },
          }
        : state;
    case ActionKeys.PROMO_CODE_APPLY_OR_REPLACE:
      return {
        ...state,
        errorCode: '',
      };
    case ActionKeys.PROMO_CODE_APPLY_OR_REPLACE_ERROR:
      return {
        ...state,
        errorCode: action.error.message,
      };
    default:
      return state;
  }
}
